import { createFileRoute } from "@tanstack/react-router";

import { CoachProductLayout } from "src/pages/CoachProductLayout";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/_tabs",
)({
  component: CoachProductLayout,
  ssr: true,
});
